<template>
  <div class="programs">
    <div class="programs-wrapper">
      <p
        v-if="computedProgramsLength > 0"
        class="programs__count"
      >
        {{ $t('messages.sharedTexts.showing') }} <strong>{{ computedProgramsLength }} {{ $tc('messages.sharedTexts.programs.program', 0) }}</strong>
      </p>
      <p
        v-else
        class="g-count-loader"
      >
        <span>{{ $t('messages.sharedTexts.status.loading') }}</span>
      </p>
      <ul
        v-if="computedProgramsLength > 0"
        ref="programsLayout"
        class="programs__layout"
        :class="{'programs__layout--show': programsLayoutInited}"
      >
        <li
          v-for="program in store.getData('programs')"
          :key="program.ID"
          class="programs__layout__item"
        >
          <program-component
            :ref="'id:' + program.ID"
            v-bind = "{Data: _GetFullProgramData(program), store}"
            :page-message = "PageMessage"
            :controller-group = "store.getData('controller.group')"
            :controller-mode = "store.getData('controller.mode')"
            :connection-information = "ConnectionInformation"
            :remain-time-to-subtract = "RemainTimeToSubtract"
            :rainshutdown = "rainshutdown"
            @SetPageMessage="SetPageMessage"
            @AddProgram = "AddProgram"
            @reloadProgramsLayout = "reloadProgramsLayout"
            @programLoaded="programLoaded"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import Masonry from 'masonry-layout'
import ProgramComponent from '@/components/ProgramComponent'

export default {
  name: 'Programs',
  components: {
    'program-component': ProgramComponent
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage:
    {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage:
    {
      type: Object,
      default: function() {
        return{}
      }
    },
    ConnectionInformation:
    {
      type: Object,
      default: function() {
        return{}
      }
    },
    store:
    {
      type: Object,
      default: function() {
        return{}
      }
    },
    RainshutdownStarted: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    ControllerMode: {
      type: String,
      default: null
    }
  },
  data() {
    return{
      programsLoaded: 0,
      programsLayoutInited: false,
      programsLayout: null,
      programMessage: '',
      pausedMessage: 'Paused',
      action: '',
      rainshutdown: false,
      UnixTime: 0,
      UnixTime2: 0,
      HasUnix: 0,
      RemainTimeToSubtract: 0
    }
  },
  computed: {
    computedProgramsLength() {
      return this.store.getData('programs.length')
    }
  },
  watch: {
    '$route'() {
      this.goToProgram(this.$route.query.id)
    },
    computedProgramsLength() {
      // console.debug('masonry layout update')
    },
    PageMessage(Message) {
      if(Message.target === 'AddProgram') {
        this.AddProgram()
      }
    },
    /**
     *  \brief   Handler message from CIMS server
     *  \param   msg - server message
     *  \return  void
     */
    SocketMessage(msg) {
      try {
        if(msg && msg.data && msg.data.category && msg.data.category === 'GetNewUnixTime') {
          if(this.HasUnix !== 1) {
            var date1 = new Date()
            this.UnixTime = date1.getTime()
            this.SocketMessageSend(
              {
                Category: 'ProgramTime',
                Type: 'UnixTime',
                data: this.UnixTime
              })
          }
        }
        if(msg && msg.data && msg.data.category && msg.data.category === 'Time') {
          var date = new Date()
          this.UnixTime2 = date.getTime()
          var num = (this.UnixTime2 - this.UnixTime) / 1000
          if(this.HasUnix !== 1)
            this.RemainTimeToSubtract = Math.round(num / 10) * 10
          else
            this.RemainTimeToSubtract = 0
        }

        if(msg && msg.data && msg.data.category) {
          switch(msg.data.category) {
          case'device':
            switch(msg.data.command) {
            case'start':
              if(this.action === 'Start') {
                if(msg.data.data.status === 'OK') {
                  this.programMessage = 'Success'
                  setTimeout(function() {
                    this.programMessage = ''
                  }, 3000)
                } else {
                  this.programMessage = 'Fail'
                  setTimeout(() => {
                    this.programMessage = ''
                  }, 3000)
                }
                this.action = ''
              }
              break
            case'stop':
              if(msg.data.data.status === 'OK') {
                this.programMessage = "Stop program's "
              } else {
                this.programMessage = 'Stop program fail'
              }
              break
            case'pause':
              if(msg.data.data.status === 'OK') {
                this.programMessage = "Pause program's "
              } else {
                this.programMessage = 'Pause program fail'
              }
              break
            case'resume':
              if(msg.data.data.status === 'OK') {
                this.programMessage = "Resume program's "
              } else {
                this.programMessage = 'Resume program fail'
              }
              break
            default:
              break
            }
            break
          default:
            break
          }
        }
      } catch(err) {
        console.error(err)
      }
    }
  },
  mounted() {
    this.rainshutdown = this.RainshutdownStarted.rainshutdown
    sessionStorage.setItem('route', this.$router.currentRoute.path)

    var d = new Date()
    var unix = d.getTime()
    this.SocketMessageSend({
      Category: 'ProgramTime',
      Type: 'UnixTime',
      data: unix
    })
  },
  destroyed() {
  },
  methods:
  {
    goToProgram(id) {
      if(this.$route.query.id) {
        let el = this.$refs['id:' + id][0]
        el = el.$el

        el.parentNode.classList.remove('programs__layout__item--highlighted')

        setTimeout(() => {
          el.parentNode.classList.add('programs__layout__item--highlighted')
          this.$el.parentNode.scrollTop += (el.getBoundingClientRect().y +  el.offsetHeight / 2) - (window.innerHeight) / 2
        }, 0)
      }
    },
    _GetFullProgramData(program) {
      this.$set(program, 'capabilities', this.store.getData('capabilities'))
      return program
    },
    programLoaded(data) {
      this.programsLoaded += 1

      if(this.programsLoaded === this.computedProgramsLength) {
        // console.debug('all programs loaded')
        this.$set(this, 'programsLayout', new Masonry( this.$refs.programsLayout, {
          itemSelector: '.programs__layout__item',
          columnWidth: '.programs__layout__item',
          horizontalOrder: true,
          isFitWidth: true
        }))
        this.programsLayoutInited = true
        this.goToProgram(this.$route.query.id)
      }
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    reloadProgramsLayout() {
      this.programsLayout.layout()
    },
    AddProgram(Data) {
      Data = (Data !== undefined) ? Data : {}
      this.$set(Data, 'capabilities', this.store.getData('capabilities'))
      Data.component = 'EditPrograms'
      this.$emit('ShowModal', {
        component: 'EditPrograms',
        data: {
          data: Data,
          steps: [
          {
            component: 'edit-program-type',
            state: '',
            name: 'Set Type'
          },
          {
            component: 'edit-program-run-times',
            state: '',
            name: 'Set Run Times'
          },
          {
            component: 'edit-program-start-times',
            state: '',
            name: 'Set Start Times'
          },
          {
            component: 'edit-program-parameters',
            state: '',
            name: 'Parameters'
          }
        ]}
      })
    },
    refreshProgramList() {
      this.SocketMessageSend({
        component: 'Programs',
        command: 'Mounted'
      })
    }
  }
}
</script>
<style lang="scss">
.programs {
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
    100% {
      opacity: 1;
    }
  }

  width: 95%;
  max-width: 100%;
  padding-top: 50px;

  .g-count-loader {
    position: fixed;
    top: 47vh;
    left: 50vw;
    transform: translate3d(-50%, -50%, 0);
  }

  &-wrapper {
    position: relative;
    width: 100%;
    max-width: $bp-desktop * 1.5;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 30px 0 70px;

    .no-wheel & {
      padding: 0 40px 0 41px;
    }
  }

  &__count {
    text-align: right;
    margin: 10px 50px;
  }

  &__layout {
    @include clearfix();
    margin: 0 auto;
    position: relative;
    opacity: 0;
    transition: opacity 0.4s;

    &--show {
      opacity: 1;
    }

    &__item {
      display: block;
      transform-origin: top left;
      transform: scale(0.89);

      &--highlighted {
        animation: pulse 1s 4;
      }
    }

  }
}

@media screen and (min-width: $bp-mobile) {
  .programs {
    padding-left: 50px;

    &__layout {
      &__item {
        transform: scale(1);
      }
    }
  }
}

</style>
